import { Button } from '@framework/ui/atoms/Button';
import { GeneralModal } from '@framework/ui/elements/GeneralModal';
import { ViewModelTagOperation } from '@view-model/domain/view-model/ViewModelTagOperation';
import { useCallback } from 'react';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
type Props = {
  isOpen: boolean;
  onClose(): void;
  groupId: string;
  tagId: string;
  tagName: string;
  viewModelId: string;
};

export const ViewModelTagUnassignConfirmModal: React.FC<Props> = ({
  isOpen,
  onClose,
  groupId,
  tagId,
  tagName,
  viewModelId,
}: Props) => {
  const { t } = useTranslation();
  const handleSubmit = useCallback(async () => {
    try {
      await ViewModelTagOperation.unassign(groupId, tagId, viewModelId);
    } catch (e) {
      toast.error(t('common.message.unknownError'));
      console.error(e);
    }
    onClose();
  }, [groupId, onClose, t, tagId, viewModelId]);

  return (
    <GeneralModal
      isOpen={isOpen}
      onClose={onClose}
      title={t('viewModel.tag.unassign.title')}
      submitButton={<Button onClick={handleSubmit}>{t('viewModel.tag.unassign.confirm')}</Button>}
      cancelButton={
        <Button color="secondary" onClick={onClose}>
          {t('common.action.cancel')}
        </Button>
      }
    >
      <div>
        <p>{t('viewModel.tag.unassign.description', { tagName })}</p>
      </div>
    </GeneralModal>
  );
};
